(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["marketit-buybox-content"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-marketit-buybox]').forEach((buybox) => {
    const productId = buybox.dataset.productId;
    const priceBlock = buybox.querySelector('[ref="priceBlock"]');
    const stockPill = buybox.querySelector('[ref="stockPill"]');
    const buyButtons = buybox.querySelector('[ref="buyButtons"]');

    function money(cents) {
      return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' });
    }

    // Real stock check: a variant can still be `available` with 0 units when
    // "continue selling when out of stock" is on, which would let the native
    // buy-buttons block accept an order on an empty variant. Force-disable
    // the add-to-cart button, quantity selector and accelerated checkout in
    // that case, regardless of what the native block computed.
    function applyStockState({ managed, quantity, threshold }) {
      const reallyOut = managed && quantity <= 0;
      const low = managed && quantity > 0 && threshold > 0 && quantity <= threshold;

      if (stockPill) {
        stockPill.classList.toggle('marketit-buybox__stock-pill--out', reallyOut);
        stockPill.classList.toggle('marketit-buybox__stock-pill--low', low);
        stockPill.lastChild.textContent = reallyOut
          ? ' Épuisé'
          : low
            ? ` Plus que ${quantity} en stock — expédié aujourd’hui`
            : ' En stock — expédié aujourd’hui';
      }

      if (buyButtons) {
        const addButton = buyButtons.querySelector('[ref="addToCartButton"]');
        const qtyInput = buyButtons.querySelector('quantity-selector-component input, input[name="quantity"]');
        const qtySelector = buyButtons.querySelector('quantity-selector-component');
        const accelerated = buyButtons.querySelector('.accelerated-checkout-block');

        if (addButton) {
          addButton.disabled = reallyOut || addButton.disabled;
          if (reallyOut) {
            addButton.disabled = true;
            const label = addButton.querySelector('.add-to-cart-text__content');
            if (label) label.textContent = 'Épuisé';
          }
        }
        if (qtyInput) qtyInput.disabled = reallyOut;
        qtySelector?.classList.toggle('marketit-buybox__qty--disabled', reallyOut);
        accelerated?.toggleAttribute('hidden', reallyOut);
      }
    }

    if (buyButtons) {
      applyStockState({
        managed: buyButtons.dataset.inventoryManaged === 'true',
        quantity: parseInt(buyButtons.dataset.inventoryQuantity, 10) || 0,
        threshold: parseInt(buyButtons.dataset.lowStockThreshold, 10) || 0,
      });
    }

    function updateForVariant(variant) {
      if (!variant) return;

      if (priceBlock) {
        const priceNow = priceBlock.querySelector('.marketit-buybox__price-now');
        if (priceNow) priceNow.textContent = money(variant.price);
        const priceWas = priceBlock.querySelector('.marketit-buybox__price-was');
        const discountTag = priceBlock.querySelector('.marketit-buybox__discount-tag');
        if (variant.compare_at_price > variant.price) {
          if (priceWas) {
            priceWas.textContent = money(variant.compare_at_price);
          } else {
            const span = document.createElement('span');
            span.className = 'marketit-buybox__price-was';
            span.textContent = money(variant.compare_at_price);
            priceBlock.appendChild(span);
          }
          if (discountTag) {
            discountTag.textContent = '-' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%';
          }
        } else {
          if (priceWas) priceWas.remove();
          if (discountTag) discountTag.remove();
        }
      }

      const threshold = parseInt(buyButtons?.dataset.lowStockThreshold, 10) || 0;
      applyStockState({
        managed: variant.inventory_management === 'shopify',
        quantity: variant.inventory_quantity ?? 0,
        threshold,
      });
    }

    document.addEventListener('variant:update', (event) => {
      if (event.detail?.data?.productId && event.detail.data.productId !== productId) return;
      updateForVariant(event.detail?.resource);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["marketit-cart-summary"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-marketit-discount-form]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const input = form.querySelector('input[name="discount"]');
      const code = input?.value.trim();
      if (!code) return;

      const existing = (form.dataset.existingDiscounts || '').split(',').filter(Boolean);
      if (existing.includes(code)) return;

      fetch('/cart/update.js', {
        method: 'post',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: existing.concat(code).join(',') }),
      })
        .then((response) => response.json())
        .then(() => window.location.reload())
        .catch(() => form.submit());
    });
  });
  } catch(e) { console.error(e); }
})();

})();
